import Vue from 'vue';
import api from '../http/index';
import VueRouter from "vue-router";
import _ from "underscore";
import store from "../store";
import storage from "../core/utils/storage";
import menuUtil from "../core/utils/menu";
import dot from '../common/js/dot/index'

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const pathExist = {
    "/main/home": resolve => require(['../page/home/home'], resolve),
    "/main/talk": resolve => require(['../page/im/im-chat.vue'], resolve),
    //二级菜单
    "/main/user": resolve => require(['../layout/Second'], resolve),
    "/main/company": resolve => require(['../layout/Second'], resolve),
    "/main/withdrawManage": resolve => require(['../layout/Second'], resolve),
    "/main/merchant-withdraw": resolve => require(['../layout/Second'], resolve),
    "/main/merchant-agent": resolve => require(['../layout/Second'], resolve),
    "/main/remitCenter": resolve => require(['../layout/Second'], resolve),
    "/main/deposit": resolve => require(['../layout/Second'], resolve),
    "/main/exchangeCenter": resolve => require(['../layout/Second'], resolve),
    "/main/system-settings": resolve => require(['../layout/Second'], resolve),
    "/main/agent-approval-center": resolve => require(['../layout/Second'], resolve),
    "/main/report": resolve => require(['../layout/Second'], resolve),
    "/main/anchorCompany": resolve => require(['../layout/Second'], resolve),
    "/main/project-mgr": resolve => require(['../layout/Second'], resolve),
    "/main/otc-mgr": resolve => require(['../layout/Second'], resolve),
    "/main/tok-mgr": resolve => require(['../layout/Second'], resolve),
    "/main/sgb-mgr": resolve => require(['../layout/Second'], resolve),
    "/main/community-mgr": resolve => require(['../layout/Second'], resolve),
    "/main/org-team-mgr": resolve => require(['../layout/Second'], resolve),
    //达人互动
    "/main/influencer": resolve => require(['../layout/Second'], resolve),
    "/main/marketer": resolve => require(['../layout/Second'], resolve),

    //子菜单
    "/main/user/user-list": resolve => require(['../page/userManage/user'], resolve),
    "/main/user/customer-service-list": resolve => require(['../page/userManage/customer-service-list'], resolve),
    "/main/user/userReview": resolve => require(['../page/userManage/userReview'], resolve),
    "/main/user/limitApproval": resolve => require(['../page/userManage/approvalLimit'], resolve),
    "/main/company/company-list": resolve => require(['../page/companyManage/company'], resolve),
    "/main/company/company-account": resolve => require(['../page/companyManage/company-account'], resolve),
    "/main/company/branchCompany-account": resolve => require(['../page/companyManage/companyAgent-account'], resolve),
    "/main/company/quota-approval": resolve => require(['../page/companyManage/quota-approval'], resolve),
    "/main/company/withdrawal": resolve => require(['../page/companyManage/withdrawal'], resolve),
    "/main/withdrawManage/withdraw": resolve => require(['../page/withdraw-manage/withdrawManage'], resolve),
    "/main/withdrawManage/manual": resolve => require(['../page/withdraw-manage/manual'], resolve),
    "/main/withdrawManage/withdraw-list": resolve => require(['../layout/Third'], resolve),
    "/main/withdrawManage/withdrawSearch": resolve => require(['../page/withdraw-manage/withdrawSearch'], resolve),
    "/main/withdrawManage/percentageSearch": resolve => require(['../page/withdraw-manage/percentageSearch'], resolve),
    "/main/withdrawManage/withdrawFault": resolve => require(['../page/withdraw-manage/withdrawFault'], resolve),
    "/main/withdrawManage/withdrawChannel": resolve => require(['../page/withdraw-manage/withdrawChannel'], resolve),
    "/main/withdrawManage/withdrawFreeze": resolve => require(['../page/withdraw-manage/withdraw-freeze'], resolve),
    "/main/withdrawManage/matchFailed": resolve => require(['../page/withdraw-manage/matchFailed'], resolve),
    "/main/merchant": resolve => require(['../layout/Third'], resolve),
    "/main/merchant/merchant-list": resolve => require(['../page/merchant/merchant-list'], resolve),
    "/main/merchant/settlement-center": resolve => require(['../page/merchant/settlement-center'], resolve),
    "/main/merchant/agent/check-center": resolve => require(['../page/agent-management/merchant-settlement'], resolve),
    "/main/merchant/quota-approval": resolve => require(['../page/merchant/quota-approval'], resolve),
    //"/main/head/quarters/check-center": resolve => require(['../page/head-office/by-flow'], resolve),
    "/main/merchant/raise": resolve => require(['../page/merchant/mechant-raise'], resolve),
    "/main/merchant/merchant-digital": resolve => require(['../page/merchant/merchant-digital'], resolve),
    "/main/merchant/group-digital": resolve => require(['../page/merchant/group-digital'], resolve),
    "/main/merchant/setDigi": resolve => require(['../page/merchant/setDigi'], resolve),

    // "/main/agent-management": resolve => require(['../layout/Second'], resolve),
    // "/main/agent-management/agent-list": resolve => require(['../page/agent-management/agent-list'], resolve),
    "/main/merchant/agent/list-center": resolve => require(['../page/agent-management/angentMerchant-list'], resolve),
    "/main/agent-management/merchantAgentFlow": resolve => require(['../page/agent-management/merchantAgent-flow'], resolve),
    //"/main/agent-management/settlement-center": resolve => require(['../page/agent-management/settlement-center'], resolve),
    "/main/exchangeCenter/exchange": resolve => require(['../page/exchangeCenter/exchange-center'], resolve),
    "/main/exchangeCenter/fee": resolve => require(['../page/exchangeCenter/exchange-fee'], resolve),
    "/main/exchangeCenter/exchange-cash": resolve => require(['../page/exchangeCenter/exchange-cash'], resolve),
    "/main/exchangeCenter/exchange-entrust": resolve => require(['../page/exchangeCenter/exchange-entrust'], resolve),

    "/main/remitCenter/remit": resolve => require(['../page/remitCenter/remit-center'], resolve),
    "/main/remitCenter/remit-fault": resolve => require(['../page/remitCenter/remit-fault'], resolve),
    "/main/deposit/financial-products": resolve => require(['../layout/Third'], resolve),
    "/main/deposit/financial-products/product-management": resolve => require(['../page/financial-products/product-management'], resolve),
    "/main/deposit/financial-products/lucky-finance": resolve => require(['../page/financial-products/lucky-finance'], resolve),
    "/main/deposit/financial-products/product-report": resolve => require(['../page/financial-products/product-report'], resolve),
    "/main/deposit/deposit-list": resolve => require(['../layout/Third'], resolve),
    "/main/deposit/deposit-list/deposit-order-query": resolve => require(['../page/deposit-list/deposit-order-query'], resolve),
    "/main/deposit/deposit-list/deposit-commission": resolve => require(['../page/deposit-list/deposit-commission'], resolve),
    "/main/deposit/deposit-list/deposit-fault": resolve => require(['../page/deposit-list/deposit-fault'], resolve),
    "/main/deposit/deposit-list/deposit-freeze": resolve => require(['../page/deposit-list/deposit-freeze'], resolve),
    "/main/single-page/cooperation": resolve => require(['../page/single-page/cooperation'], resolve),
    //主播充值列表
    //  "/main/anchor/rechargeList/rechargeList": resolve => require(['../layout/Third'], resolve),//主播充值列表管理二级页面
    //   "/main/anchor/rechargeList/rechargeList/recharge-order-query": resolve => require(['../page/anchor/rechargeList/recharge-order-query'], resolve),//主播充值订单查询
    //   "/main/anchor/rechargeList/rechargeList/recharge-commission": resolve => require(['../page/anchor/rechargeList/recharge-commission'], resolve),//主播手续费查询
    //   "/main/anchor/rechargeList/rechargeList/recharge-fault": resolve => require(['../page/anchor/rechargeList/recharge-fault'], resolve),//主播故障单查询
    //  "/main/anchor/rechargeList/rechargeList/recharge-freeze": resolve => require(['../page/anchor/rechargeList/recharge-freeze'], resolve),//充值冻结申请和冻结记录

    "/main/ops-mgr/sys-config-center": resolve => require(['../page/system-settings/sys-config-center/sys-config-center'], resolve), //系统配置中心 (t_sys_config)：V4.2.5 菜单迁到运维管理下，URL 随之改（须与父级 /main/ops-mgr 前缀一致，否则嵌套路由渲染不出）
    "/main/system-settings/sys-config-center": resolve => require(['../page/system-settings/sys-config-center/sys-config-center'], resolve), //旧路径兼容保留
    "/main/system-settings/my-wallet": resolve => require(['../page/system-settings/my-wallet/my-wallet'], resolve), //我的钱包（旧位置兼容，新位置在「个人中心」一级菜单下）

    // V4.1.0 「个人中心」一级菜单 + 3 子菜单
    "/main/personal-center": resolve => require(['../layout/Second'], resolve),
    "/main/personal-center/personal-info": resolve => require(['../page/system-settings/user-center'], resolve), //个人信息（复用 user-center，路由分发只显示信息区）
    "/main/personal-center/my-documents":  resolve => require(['../page/system-settings/user-center'], resolve), //我的文档（复用 user-center，路由分发只显示文件区）
    "/main/personal-center/my-wallet":     resolve => require(['../page/system-settings/my-wallet/my-wallet'], resolve), //我的钱包（新位置）
    "/main/system-settings/bank-list": resolve => require(['../page/system-settings/bank-list'], resolve),
    "/main/system-settings/bank-card-list": resolve => require(['../page/system-settings/bank-card-list'], resolve),
    "/main/system-settings/employee-list": resolve => require(['../page/system-settings/employee-list'], resolve),
    "/main/system-settings/role": resolve => require(['../page/system-settings/role/index'], resolve),
    "/main/system-settings/menu": resolve => require(['../page/system-settings/menu/index'], resolve),
    "/main/system-settings/platform-account": resolve => require(['../page/system-settings/platform-account/index'], resolve),
    "/main/system-settings/user-center": resolve => require(['../page/system-settings/user-center'], resolve),

    "/main/system-settings/Ad": resolve => require(['../page/system-settings/Ad'], resolve), //广告界面
    "/main/system-settings/systemNotification": resolve => require(['../page/system-settings/systemNotification'], resolve), //系统广告
    "/main/system-settings/currency-list": resolve => require(['../page/system-settings/currency-list/currency-list'], resolve),
    "/main/system-settings/exchangeSetting": resolve => require(['../page/system-settings/exchange-setting/exchange'], resolve),
    "/main/system-settings/veChannel": resolve => require(['../page/system-settings/veChannel/veChannel'], resolve),
    "/main/deposit/financial-products/merchant-product-report": resolve => require(['../page/financial-products/merchant-product-report'], resolve),

    "/main/agent-approval-center/apply": resolve => require(['../page/agent-approval-center/apply/apply-list'], resolve),
    "/main/agent-approval-center/approval": resolve => require(['../page/agent-approval-center/approval/approval-list'], resolve),
    // "/main/report/controlling-company": resolve => require(['../page/report/controlling-company'], resolve),
    //"/main/report/profitStatement": resolve => require(['../page/report/profitStatement'], resolve),
    "/main/report/movie": resolve => require(['../page/movie/movie'], resolve), //先跳转到电影区

    "/main/report/branch-statistics": resolve => require(['../page/report/branch-statistics'], resolve),
    "/main/report/user-report": resolve => require(['../page/report/user-report'], resolve),
    "/main/report/company-report": resolve => require(['../page/report/company-report'], resolve),
    "/main/report/merchant-funds": resolve => require(['../page/report/merchant-funds'], resolve),
    "/main/report/agency-profit": resolve => require(['../page/report/agency-profit'], resolve),
    "/main/report/agency-transaction": resolve => require(['../page/report/agency-transaction'], resolve),
    "/main/report/agentCustomerStatisticsReport": resolve => require(['../page/report/agentCustomerStatisticsReport'], resolve),
    "/main/report/online-report": resolve => require(['../page/report/online-report'], resolve),
    "/main/channel/channel": resolve => require(['../page/channel/channel'], resolve),
    "/main/dealWith/faultDispatch": resolve => require(['../page/dealWithFault/faultDispatch'], resolve),
    "/main/error/errorRemittance": resolve => require(['../page/errorRemittance/errorRemittance'], resolve), //错误汇款处理
    "/main/present/present": resolve => require(['../page/present/present'], resolve),
    // "/main/anchorCompany/anchorCompany": resolve => require(['../page/anchorCompany/anchorCompany'], resolve),
    // "/main/anchor/anchonrDigital": resolve => require(['../page/anchor/anchonrDigital'], resolve),//直播公司数字货币审核
    // "/main/anchorCompany/withdrawal": resolve => require(['../page/anchorCompany/withdrawal'], resolve),
    // "/main/anchorCompany/flow-approval": resolve => require(['../page/anchorCompany/flow-approval'], resolve),
    // "/main/anchor": resolve => require(['../layout/Second'], resolve),
    // "/main/anchor/list": resolve => require(['../page/anchor/list'], resolve),
    // "/main/anchor/flow-approval": resolve => require(['../page/anchor/flow-approval'], resolve),
    // "/main/giftRecords": resolve => require(['../layout/Second'], resolve),
    // "/main/giftRecords/giftRecord": resolve => require(['../page/giftRecords/giftRecord'], resolve),
    // "/main/shortVideoManage": resolve => require(['../page/shortVideoManage/index'], resolve),
    // "/main/giftRecords/giftRecord": resolve => require(['../page/giftRecords/giftRecord'], resolve),
    // "/main/liveManage": resolve => require(['../layout/Second'], resolve),
    // "/main/liveManage/recommend": resolve => require(['../page/liveManage/recommend'], resolve),
    // "/main/liveManage/livingRoom": resolve => require(['../page/liveManage/livingRoom'], resolve),
    "/main/report/group-reconciliation": resolve => require(['../page/report/group-reconciliation'], resolve),
    "/main/token-project": resolve => require(['../page/token-project/list'], resolve),
    "/main/project/project-otc": resolve => require(['../page/token-project/project-otc'], resolve),
    "/main/project/project-sgb": resolve => require(['../page/token-project/project-sgb'], resolve),
    "/main/project/project-sqt": resolve => require(['../page/token-project/project-sqt'], resolve),
    "/main/project/project-tok": resolve => require(['../page/token-project/project-tok'], resolve),
    "/main/project/holding/list": resolve => require(['../page/token-project/holding/list'], resolve),
    "/main/project/dividend-record-mgr": resolve => require(['../page/token-project/dividend-record-mgr'], resolve),
    "/main/invest-project-prepare": resolve => require(['../page/invest-project-prepare/list'], resolve),
    /**
     * 订单模块
     */
    "/main/order/withdraw/order-withdraw-list/remit": resolve => require(['../page/order/withdraw/order-withdraw-list'], resolve),
    "/main/order/withdraw/order-withdraw-list/cash": resolve => require(['../page/order/withdraw/order-withdraw-list'], resolve),
    "/main/otc-mgr/list": resolve => require(['../page/otc-mgr/list'], resolve),
    "/main/otc-mgr/list-robbing": resolve => require(['../page/otc-mgr/list-robbing'], resolve),
    "/main/otc-mgr/fee-rate-setting": resolve => require(['../page/otc-mgr/fee-rate-setting'], resolve),
    //otc做市商申请管理
    "/main/otc-mgr/otc-application-mgr": resolve => require(['../page/otc-mgr/otc-application-mgr'], resolve),
    "/main/otc-mgr/otc-ad-mgr": resolve => require(['../page/otc-mgr/otc-ad-mgr'], resolve),
    "/main/otc-mgr/otc-order-mgr": resolve => require(['../page/otc-mgr/otc-order-mgr'], resolve),

    "/main/crypto-mgr/list-recharge": resolve => require(['../page/crypto-mgr/list-recharge'], resolve),
    "/main/crypto-mgr/list-withdrawal": resolve => require(['../page/crypto-mgr/list-withdrawal'], resolve),
    "/main/crypto-mgr/list-transfer": resolve => require(['../page/crypto-mgr/list-transfer'], resolve),
    "/main/pledge-product/pledge-tok": resolve => require(['../page/pledge-product/pledge-tok'], resolve),
    "/main/pledge-product/pledge-sqt": resolve => require(['../page/pledge-product/pledge-sqt'], resolve),
    "/main/pledge-product/pledge-otc": resolve => require(['../page/pledge-product/pledge-otc'], resolve),
    "/main/pledge-record/list-tok": resolve => require(['../page/pledge-record/list-tok'], resolve),
    "/main/pledge-record/list-sqt": resolve => require(['../page/pledge-record/list-sqt'], resolve),
    "/main/pledge-record/list-otc": resolve => require(['../page/pledge-record/list-otc'], resolve),

    /**
     * 社区管理
     */
    "/main/community/list": resolve => require(['../page/community/community-list'], resolve),
    /**
     * 团队阵容管理
     */
    "/main/org-team/list": resolve => require(['../page/org-team/list'], resolve),
    //达人任务管理
    "/main/influencer/influencer-apply": resolve => require(['../page/influencer/influencer-apply'], resolve),
    "/main/influencer/influencer-list": resolve => require(['../page/influencer/influencer-list'], resolve),
    "/main/influencer/influencer-task-mgr": resolve => require(['../page/influencer/influencer-task-mgr'], resolve),
    "/main/influencer/influencer-task-claim-mgr": resolve => require(['../page/influencer/influencer-task-claim-mgr'], resolve),
    "/main/influencer/influencer-task-data": resolve => require(['../page/influencer/influencer-task-data'], resolve),
    //达人任务管理
    "/main/marketer/marketer-application-mgr": resolve => require(['../page/marketer/marketer-application-mgr'], resolve),
    "/main/marketer/marketer-info-mgr": resolve => require(['../page/marketer/marketer-info-mgr'], resolve),
    "/main/marketer/marketer-service-mgr": resolve => require(['../page/marketer/marketer-service-mgr'], resolve),
    "/main/marketer/marketer-remote-host-mgr": resolve => require(['../page/marketer/marketer-remote-host-mgr'], resolve),
    "/main/marketer/marketer-datacenter-supervisor-mgr": resolve => require(['../page/marketer/marketer-datacenter-supervisor-mgr'], resolve),
    "/main/marketer/marketer-customer-manager-mgr": resolve => require(['../page/marketer/marketer-customer-manager-mgr'], resolve),
    "/main/marketer/marketer-customer-mgr": resolve => require(['../page/marketer/marketer-customer-mgr'], resolve),
    "/main/marketer/model-mgr":     resolve => require(['../page/marketing/model-mgr/model-mgr'], resolve), //模特管理
    "/main/marketer/model-plaza":   resolve => require(['../page/marketing/model-plaza/model-plaza'], resolve), //模特广场（含下单）
    "/main/marketer/fan-orders":    resolve => require(['../page/marketing/fan-orders/fan-orders'], resolve), //我的引粉订单
    "/main/marketer/project-doc-mgr": resolve => require(['../page/marketing/project-doc/project-doc-mgr'], resolve), //项目文档管理(V4.2.3)
    "/main/marketer/rental-mgr":    resolve => require(['../page/marketer/rental-mgr/index'], resolve), //设备租赁管理(定价+订单 V4.2.9)
    "/main/personal-center/project-doc": resolve => require(['../page/personal-center/project-doc'], resolve), //个人中心-项目文档(V4.2.3)
    "/main/beacon-group/customer-manager-application-mgr": resolve => require(['../page/beacon-group/customer-manager-application-mgr'], resolve),
    "/main/ops-mgr": resolve => require(['../layout/Second'], resolve), //运维管理(顶级，二级布局)
    "/main/ops-mgr/app-mgr": resolve => require(['../page/ops-mgr/app-mgr/index'], resolve), //运维管理-App管理(V4.2.4)
    "/main/ops-mgr/site-mgr": resolve => require(['../page/ops-mgr/site-mgr/index'], resolve), //运维管理-官网管理(V4.2.5)
    "/main/ops-mgr/task-mgr": resolve => require(['../page/ops-mgr/task-mgr/index'], resolve), //运维管理-定时任务管理(V4.2.8)


};

const routesI18N = [
    {
        path: '/main/home',
        component: resolve => require(['../page/home/home'], resolve),
        meta: {
            title: '主页',
            zh_cn_title: '主页',
            zh_tw_title: '主頁',
            en_title: 'Homepage',
            auth: true,
            icon: 'iconfont icon-shouye'
        },
    },
    // {
    //     path: '/main/talk',
    //     component: resolve => require(['../page/im/index'], resolve),
    //     meta: {
    //         title: '交流中心',
    //         zhCnTitle: '交流中心',
    //         enTitle: 'Exchange Center',
    //         zhTwTitle: '交流中心',
    //         auth: true,
    //         icon: "iconfont icon-xiaoxi"
    //     },
    // },
]

let routes = [
    {
        path: '/',
        redirect: '/login',
        meta: {
            showSide: false,
            auth: false
        }
    },
    {
        path: '/login',
        component: resolve => require(['../page/login'], resolve),
        meta: {
            title: '登录',
            auth: false,
            showSide: false
        }
    },
    {
        path: '/bgLogin',
        component: resolve => require(['../page/bg-login'], resolve),
        meta: {
            title: '登录',
            auth: false,
            showSide: false
        }
    },
    {
        path: '/cmRegister',
        component: resolve => require(['../page/beacon-group/customer-manager-application'], resolve),
        meta: {
            title: '商户入驻',
            auth: false,
            showSide: false
        }
    },
    {
        path: '/main',
        component: resolve => require(['../layout/main-frame.vue'], resolve),
        meta: {
            title: '主页',
            auth: true,
            showSide: true,
        },
        children: [],
    },
    {
        path: '/test/upload',
        component: resolve => require(['../page/test/upload'], resolve),
        meta: {
            title: '上传文件demo',
            auth: false,
            showSide: true,
        }
    }
];

// const allowedTypes = new Set(['hostBoss', 'customerManager']);
// if (!allowedTypes.has(Config.getUserType())) {
//     routes.push({
//         path: '/main',
//         component: resolve => require(['../layout/main-frame.vue'], resolve),
//         meta: {
//             title: '主页',
//             auth: true,
//             showSide: true,
//         },
//         children: [],
//     })
// }
const router = new VueRouter({
    routes
});

export function addMenu(userId) {
    return new Promise((resolve, reject) => {
        api.getMenuShow(userId).then(res => {
            if (res.code === 'success') {
                let menus = res.data;
                // let main = router.options.routes[2];//2是主页// 改成
                let main = router.options.routes.find(r => r.path === '/main');
                let lang = storage.get('lang');
                main.children.splice(0, main.children.length);
                for (let i = 0; i < routesI18N.length; i++) {
                    routesI18N[i].meta.title = routesI18N[i].meta[lang + '_title'];
                    main.children.push(routesI18N[i]);
                }
                for (let i = 0; i < menus.length; i++) {
                    let menu = menus[i];
                    let route = createMenu(menu);
                    main.children.push(route);
                }
                console.log('打印下main路由：', main)
                // router.options.routes.push({path: '*', redirect: '/login'}); //访问意料之外的路由时重定向到登录
                router.addRoutes(router.options.routes);

                let vueMenu = [];
                let mainMenu = _.find(router.options.routes, item => {
                    return item.path === '/main';
                });

                if (mainMenu) {
                    _.each(mainMenu.children, option => {
                        let routeMenu = createVueMenu(option, true);
                        if (routeMenu) {
                            vueMenu.push(routeMenu);
                        }
                    });
                }

                store.commit('setMenu', vueMenu);
                store.commit('addTag', vueMenu[0]); //默认第一个菜单
                let userId = storage.get('userId');
                if (userId && userId != 2) {
                    setTimeout(() => {
                        dot.DLTX();
                    }, 1000);
                    setTimeout(() => {
                        dot.companyDot();
                    }, 1100);
                    setTimeout(() => {
                        dot.merchantDot();
                    }, 1200);
                    setTimeout(() => {
                        dot.remitDot();
                    }, 1300);
                    setTimeout(() => {
                        dot.companyMerchant();
                    }, 1400);
                    setTimeout(() => {
                        dot.merchantLLDot();
                    }, 1500);
                    setTimeout(() => {
                        dot.userTS();
                    }, 1600);
                    setTimeout(() => {
                        dot.merchantGold();
                    }, 1700);
                    setTimeout(() => {
                        dot.userTX();
                    }, 1800);
                    setTimeout(() => {
                        dot.PTLC();
                    }, 1900);
                    setTimeout(() => {
                        dot.QQLC();
                    }, 2000);
                    setTimeout(() => {
                        dot.SHLC();
                    }, 2100);
                    setTimeout(() => {
                        dot.SHDJ();
                    }, 2200);
                    setTimeout(() => {
                        dot.DHSP();
                    }, 2300);
                    setTimeout(() => {
                        dot.HKSP();
                    }, 2400);
                    setTimeout(() => {
                        dot.chatDot();
                    }, 2500);
                    setTimeout(() => {
                        dot.DLTXHEAD();
                    }, 2600);
                    setTimeout(() => {
                        dot.HEADLL();
                    }, 2700);
                    setTimeout(() => {
                        dot.MAFlow();
                    }, 2800);
                    setTimeout(() => {
                        dot.FLOWDot();
                    }, 2900);
                    // setTimeout(() => {
                    //     dot.anchorCompanyFlow();
                    // }, 3000);
                    // setTimeout(() => {
                    //     dot.anchorFlow();
                    // }, 3100);
                    // setTimeout(() => {
                    //     dot.anchorCompanyTX();
                    // }, 3200);
                    setTimeout(() => {
                        dot.comWithdrawal();
                    }, 3300);
                    setTimeout(() => {
                        dot.SHSZHBSP();
                    }, 3400);
                    setTimeout(() => {
                        dot.matchFailed();
                    }, 3500);
                    // setTimeout(() => {
                    //     dot.anchorFaultdError();
                    // },3500);
                    // setTimeout(() => {
                    //     dot.anchorDigitCurrency();
                    // },3600);
                    setTimeout(() => {
                        dot.addAdminLuckMeesage();
                    }, 3700);
                }
                resolve();
            } else {
                reject();
            }
        }).catch(() => {
            reject();
        });
    });
}


//递归获取菜单数据 存放在vuex中
function createVueMenu(option, parentShowSide) {

    if (!parentShowSide) {
        return null;
    }
    let showSide = option.meta.showSide;
    if (showSide !== undefined && showSide || showSide === undefined) {
        let menuX = {};
        menuX.path = option.path;
        menuX.icon = option.meta.icon;
        menuX.messageType = option.messageType;
        menuX.dot = 0;
        menuX.title = option.meta.title;
        menuX.name = option.name;
        menuX.children = [];
        if (option.children && option.children.length) {
            _.each(option.children, (childOption) => {
                let childMenu = createVueMenu(childOption, option.meta.showSide | parentShowSide);
                if (childMenu) {
                    menuX.children.push(childMenu);
                }
            });
        }

        return menuX;
    }
    return null;
}

function createMenu(menu) {
    function handleUrl(url) {
        const queryIndex = url.indexOf('?');
        if (queryIndex !== -1) return url.substring(0, queryIndex);
        return url;
    }

    let route = {};
    route.path = handleUrl(menu.url);
    route.fullPath = menu.url;
    route.messageType = menu.messageType;
    route.component = pathExist[handleUrl(menu.url)];
    if (handleUrl(menu.url) != menu.url) {
        console.log('打印组件：', menu.url)
    }
    route.meta = {};
    route.meta.title = menu.name;
    route.meta.icon = menu.icon;
    if (menu.subMenus && menu.subMenus.length > 0) {
        route.children = [];
        for (let i = 0; i < menu.subMenus.length; i++) {
            let sub = createMenu(menu.subMenus[i]);
            sub.parnet = menu;
            route.children.push(sub);
        }
    }
    return route;
}

router.beforeEach((to, from, next) => {
    let token = storage.get('token');
    if (!token) {
        if (to.path === '/login' || to.path === '/bgLogin' || to.path === '/cmRegister') {
            next();
        } else {
            next({
                path: '/login'
            });
        }
    } else {
        console.log('即将跳转1：', from)
        console.log('即将跳转2：', to)
        next();
    }
});
// router.beforeEach((to, from, next) => {
//     let token = storage.get('token');
//     if (!token) {
//         // 如果没有token，并且目标路径不是/login，则重定向到登录页
//         if (to.path !== '/login') {
//             next({path: '/login'});
//         } else {
//             next();
//         }
//     } else {
//         // 如果有token，检查是否是有效的路径或带查询参数的路径
//         const matched = router.getMatchedComponents(to);
//
//         if (matched.length === 0) {
//             // 如果没有匹配的组件，说明这是一个无效路径，重定向到登录页
//             next({path: '/login'});
//         } else {
//             console.log('当前路由：', router.currentRoute)
//             console.log('来自router：', router)
//             console.log('来自路由：', from)
//             console.log('跳转路径：', to)
//             // 如果有匹配的组件，继续导航
//             next();
//         }
//     }
// });


router.afterEach((to, from) => {
    window.document.title = to.meta.title;
    if (to.path === '/' || to.path === '/login' || to.path === '/main') {
        return;
    }
    let route = menuUtil.convertRouter(to);
    store.commit('addTag', route); //强制刷新的菜单
});

export default router;